import { useEffect, useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input,
    Textarea,
} from '@chakra-ui/react';
import { Permission, Role } from '@bluefalcon/users-management-client-fetch';

type AddEditIAMModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onCreate: (data: { name: string; description: string }) => void;
    onUpdate: (id: number, data: { name: string; description: string }) => void;
    entity: 'Role' | 'Permission';
    iam?: Role | Permission;
};

export function AddEditIAMModal({
    isOpen,
    onClose,
    onCreate,
    onUpdate,
    entity,
    iam,
}: AddEditIAMModalProps) {
    const [name, setName] = useState(iam?.name ?? '');
    const [description, setDescription] = useState(iam?.description ?? '');

    useEffect(() => {
        setName(iam?.name ?? '');
        setDescription(iam?.description ?? '');
    }, [iam]);

    const handleCreate = () => {
        onCreate({ name, description });
        setName('');
        setDescription('');
        onClose();
    };

    const handleUpdate = () => {
        onUpdate(iam!.id, { name, description });
        setName('');
        setDescription('');
        onClose();
    };

    const handleSubmit = () => {
        if (iam) {
            handleUpdate();
        } else {
            handleCreate();
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{iam ? `Edit ${entity}` : `Create ${entity}`}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl id="name" isRequired>
                        <FormLabel>Name</FormLabel>
                        <Input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter name"
                        />
                    </FormControl>

                    <FormControl id="description" isRequired mt={4}>
                        <FormLabel>Description</FormLabel>
                        <Textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter description"
                            rows={4}
                        />
                    </FormControl>
                </ModalBody>

                <ModalFooter>
                    <Button
                        colorScheme="primary"
                        mr={3}
                        onClick={handleSubmit}
                    >
                        {iam ? 'Update' : 'Create'}
                    </Button>
                    <Button variant="ghost" onClick={onClose}>
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
